import React from 'react'
import {Loader} from 'semantic-ui-react'
import {RedocStandalone} from 'redoc'
import _ from 'lodash'
import {asJson} from "../../../../util"
import {useSafeState} from '../../../../hook'

const RedocUI = (
  {
    contract
  }
) => {
  contract = contract || {definition: ''}
  const [loading, setLoading] = useSafeState(true)

  const redocProps = {
    options: {
      hideLoading: true,
      nativeScrollbars: true,
      theme: {colors: {main: '#dd5522'}}
    },
    onLoaded: () => {
      setTimeout(() => {
        setLoading(false)
      }, 500)
    }
  }
  if (_.isString(contract)) {
    redocProps.specUrl = contract
  } else {
    redocProps.spec = asJson(contract.definition)
  }

  return (
    <div data-testid='docs-redoc-container'>
      {loading && (<Loader active={loading} inline='centered'/>)}
      <div style={{display: loading ? 'none' : 'block'}}>
        <RedocStandalone {...redocProps}/>
      </div>
    </div>
  )
}

export {RedocUI}

export default RedocUI